// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputRow__co6TM9pyuN,.titleSlot__HoqEaWNsxi{padding-bottom:0 !important}.titleRow__gwY9U79xkV{box-shadow:var(--dixa-effect-box-shadow-200);z-index:1}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/search/search.view.module.scss"],"names":[],"mappings":"AAEA,6CAEE,2BAAA,CAGF,sBACE,4CAAA,CACA,SAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.inputRow,\n.titleSlot {\n  padding-bottom: 0 !important;\n}\n\n.titleRow {\n  box-shadow: var(--dixa-effect-box-shadow-200);\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputRow": `inputRow__co6TM9pyuN`,
	"titleSlot": `titleSlot__HoqEaWNsxi`,
	"titleRow": `titleRow__gwY9U79xkV`
};
export default ___CSS_LOADER_EXPORT___;
